import { RenderTree } from "src/@types/Category";
import { NodeModel } from "@minoru/react-dnd-treeview";

export const DragableTaxonomyData: NodeModel[] = [
  {
    id: 1,
    parent: 0,
    droppable: true,
    text: "Fundations of Mathematics",
  },
  {
    id: 2,
    parent: 0,
    droppable: true,
    text: "Algebra",
  },
  {
    id: 3,
    parent: 0,
    droppable: true,
    text: "Geometry",
  },
  {
    id: 4,
    parent: 0,
    droppable: true,
    text: "Calculus & Analysis",
  },
  {
    id: 5,
    parent: 0,
    droppable: true,
    text: "Statistics & Probability",
  },
  {
    id: 6,
    parent: 5,
    droppable: true,
    text: "Linear Regression",
  },
  {
    id: 7,
    parent: 5,
    droppable: true,
    text: "Probability",
  },
  {
    id: 8,
    parent: 5,
    droppable: true,
    text: "Regression",
  },
  {
    id: 9,
    parent: 8,
    droppable: true,
    text: "General Aspects",
  },
  {
    id: 10,
    parent: 8,
    droppable: true,
    text: "Foundations of probabability theory",
  },
  {
    id: 11,
    parent: 8,
    droppable: true,
    text: "Random variables",
  },
  {
    id: 12,
    parent: 11,
    droppable: true,
    text: "Discrete Random Variable",
  },
  {
    id: 13,
    parent: 11,
    droppable: true,
    text: "Expected value",
  },
  {
    id: 14,
    parent: 5,
    droppable: true,
    text: "Statistics",
  },
];

export const DragableTaxonomyData2: NodeModel[] = [
  {
    id: 1,
    parent: 0,
    droppable: true,
    text: "Number Sequence",
  },
  {
    id: 2,
    parent: 0,
    droppable: true,
    text: "Multiplication",
  },
  {
    id: 3,
    parent: 0,
    droppable: true,
    text: "Division",
  },
  {
    id: 4,
    parent: 0,
    droppable: true,
    text: "Equations",
  },
  {
    id: 5,
    parent: 0,
    droppable: true,
    text: "Geometry",
  },
  {
    id: 6,
    parent: 0,
    droppable: true,
    text: "Fractions",
  },
  // Second Level
  // Children of 1
  {
    id: 7,
    parent: 1,
    droppable: true,
    text: "Place Value Through Billions",
  },
  {
    id: 8,
    parent: 1,
    droppable: true,
    text: "Place Value & Exponents",
  },
  {
    id: 9,
    parent: 1,
    droppable: true,
    text: "Compare Whole Numbers",
  },
  {
    id: 10,
    parent: 1,
    droppable: true,
    text: "Represent Decimals",
  },
  {
    id: 11,
    parent: 1,
    droppable: true,
    text: "Compare Decimals",
  },
  {
    id: 12,
    parent: 1,
    droppable: true,
    text: "Order Whole Numbers and Decimals",
  },
  // Children of 2
  {
    id: 13,
    parent: 2,
    droppable: true,
    text: "Multiplication Patterns",
  },
  {
    id: 14,
    parent: 2,
    droppable: true,
    text: "The Distributive Property",
  },
  {
    id: 15,
    parent: 2,
    droppable: true,
    text: "Estimate Products",
  },
  {
    id: 16,
    parent: 2,
    droppable: true,
    text: "Multiply by One-Digit Numbers",
  },
  {
    id: 17,
    parent: 2,
    droppable: true,
    text: "Multiply by Two-Digit Numbers",
  },
  {
    id: 18,
    parent: 2,
    droppable: true,
    text: "Multiplication Properties",
  },
  {
    id: 19,
    parent: 2,
    droppable: true,
    text: "Extending Multiplication",
  },
  // Children of 3
  {
    id: 20,
    parent: 3,
    droppable: true,
    text: "Division Patterns",
  },
  {
    id: 21,
    parent: 3,
    droppable: true,
    text: "Estimate Quotients",
  },
  {
    id: 22,
    parent: 3,
    droppable: true,
    text: "Divide by One Digit Numbers",
  },
  {
    id: 23,
    parent: 3,
    droppable: true,
    text: "Divide by Two Digit Numbers",
  },
  // Children of 4
  {
    id: 24,
    parent: 4,
    droppable: true,
    text: "Addition and Subtraction Equations",
  },
  {
    id: 25,
    parent: 4,
    droppable: true,
    text: "Multiplication Equations",
  },
  {
    id: 26,
    parent: 4,
    droppable: true,
    text: "Geometry: Ordered Pairs",
  },
  {
    id: 27,
    parent: 4,
    droppable: true,
    text: "Algebra & Geometry: Graph Functions",
  },
  {
    id: 28,
    parent: 4,
    droppable: true,
    text: "Functions and Equations",
  },
  // Children of 5
  {
    id: 29,
    parent: 5,
    droppable: true,
    text: "Points, Lines & Rays",
  },
  {
    id: 30,
    parent: 5,
    droppable: true,
    text: "Angles",
  },
  {
    id: 31,
    parent: 5,
    droppable: true,
    text: "Triangles",
  },
  {
    id: 32,
    parent: 5,
    droppable: true,
    text: "Quadrilaterals & Polygons",
  },
  {
    id: 33,
    parent: 5,
    droppable: true,
    text: "Circles",
  },
  {
    id: 34,
    parent: 5,
    droppable: true,
    text: "Perimeter",
  },
  {
    id: 35,
    parent: 5,
    droppable: true,
    text: "Area of Parallelograms",
  },
  // Third Level
  // Children of 29
  {
    id: 36,
    parent: 30,
    droppable: true,
    text: "Acute Angle",
  },
  {
    id: 37,
    parent: 30,
    droppable: true,
    text: "Obtuse Angle",
  },
  {
    id: 38,
    parent: 30,
    droppable: true,
    text: "Right Angle",
  },
  {
    id: 39,
    parent: 30,
    droppable: true,
    text: "Straight Angle",
  },
  // Fourth Level
];

export const NonDragableTaxonomyData: RenderTree[] = [
  {
    id: "1",
    name: "Statistics & Probability",
    children: [
      {
        id: "1.1",
        name: "Regression",
        children: [
          {
            id: "1.1.1",
            name: "Random variables",
            children: [
              {
                id: "1.1.1.1",
                name: "Discrete Random Variable",
              },
            ],
          },
        ],
      },
    ],
  },
];

export const ALLOW_SELECTION_FROM_AND_ONWARDS = 0;
